<template>
    <div v-if="state">
        <pop-form class="form-box" v-if="state" width="580px">
            <template slot="title">充值</template>
            <div class="body-box">
                <el-form ref="payData" :model="payData" label-width="100px">
                    <el-col :span="24">
                        <el-form-item prop="money" label="充值金额" :rules="[{ required: true, message: '请输入充值金额', trigger: 'blur' }]">
                            <el-input v-model="payData.money"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="服务人员">
                            <el-button type="text" @click="selectStaffState = true">添加</el-button>
                            <span class="split-icon"></span>
                            <el-button type="text" @click="clearStaff">清空</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
                <div class="staff-box">
                    <el-table :data="staffListData" height="170" style="width: 100%" ref="selectTable" class="table-box-2" v-show="staffListData.length > 0">
                        <el-table-column prop="work_id" label="工号" />
                        <el-table-column prop="name" label="姓名" />
                        <el-table-column label="操作">
                            <template slot-scope="data">
                                <el-button type="text" @click="deleteStaff(data.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <template slot="foot">
                <div class="foot">
                    <div class="attach-box">
                        <el-button-group>
                            <el-button size="mini" @click="giveState = true">赠送</el-button>
                            <el-button size="mini" @click="remarkState = true">备注</el-button>
                        </el-button-group>
                    </div>
                    <div class="btn-box">
                        <el-button size="medium" @click="cancel">取消</el-button>
                        <el-button size="medium" type="primary" @click="nextStep">下一步</el-button>
                    </div>
                </div>
            </template>
        </pop-form>

        <!--结束-->
        <total-done :settle-data="settleData" v-model="doneState" :is-back="true" @settleOver="settleOver"></total-done>
        <!--赠送-->
        <cash-give v-model="giveState" :init-data="payData.give_data" @submit="setGiveData" />
        <!--备注-->
        <cash-remark v-model="remarkState" :init-data="payData.remark" @submit="setRemarkData" />
        <!--选择服务人员-->
        <CashStaffSelectBox v-model="selectStaffState" :pro-type="3" :selected-staff="staffListData" @selected="selectStaffEvent"/>
    </div>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    import TotalDone from "@/model/Cash/TotalDone";
    import CashGive from "@/model/Cash/CashGive";
    import CashRemark from "@/model/Cash/CashRemark";
    import CashStaffSelectBox from "@/model/Cash/CashStaffSelectBox";
    export default {
        name: "PayMoney",
        components: {CashStaffSelectBox, CashRemark, CashGive, TotalDone, PopForm},
        model: {
            event: "showChange",
            prop: "state"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: String,
                default: "",
            }
        },
        data: () => {
            return {
                payData: {
                    order_no: "",
                    money: "",
                    give_data: {},
                    remark: "",
                },
                vipList: [],
                storeUserInfo: {},

                settleData: {},
                doneState: false,

                giveState: false,
                remarkState: false,
                selectStaffState: false,
                staffListData: []
            };
        },
        mounted: function () {

        },
        methods: {
            //初始数据
            initData: function () {
                this.payData = {
                    order_no: "",
                    money: "",
                    give_data: {},
                    remark: "",
                };
                this.storeUserInfo = {};
                this.staffListData = [];

                this.getStoreUserInfo();
            },
            //获取VIP列表
            getVipListData: function () {
                obj.postData("store_vip/get_vip_sort_list", {}, res => {
                    if(res.errcode === 0)
                        this.vipList = res.data;
                    else
                        obj.message.error(res.errdesc);
                });
            },
            //获取用户资料
            getStoreUserInfo: function () {
                obj.postData("store_user/get_store_user_info", {id: this.storeUid}, res => {
                    if(res.errcode === 0)
                        this.storeUserInfo = res.data;
                    else
                        obj.message.error(res.errdesc);
                });
            },
            //关闭
            cancel: function () {
                this.$emit("showChange", false);
            },
            //下一步
            nextStep: function () {
                this.$refs.payData.validate(valid => {
                    if(!valid) return false;

                    this.storeUserInfo.store_uid = this.storeUserInfo.id;
                    this.settleData = {
                        cash_mode: 2,
                        allTotalPrice: parseFloat(this.payData.money),
                        user_info: this.storeUserInfo,
                        order_no: this.payData.order_no,
                        pro_data: [{
                            pro_type: 3,
                            pay_money: this.payData.money,
                            staff: this.staffListData
                        }],
                        remark: this.payData.remark,
                        give_data: this.payData.give_data,
                    };
                    this.doneState = true;
                });
            },
            //充值完成
            settleOver: function () {
                this.cancel();
                this.$emit("settleOver");
            },
            //设置赠送数据
            setGiveData: function (giveData) {
                this.payData.give_data = giveData;
            },
            //设置备注
            setRemarkData: function (remark) {
                this.payData.remark = remark;
            },
            //选择服务人员回调
            selectStaffEvent: function (staffList) {
                this.staffListData = staffList;
            },
            //删除指定服务人员
            deleteStaff: function (index) {
                this.staffListData.splice(index, 1);
            },
            //清空服务人员
            clearStaff: function () {
                this.staffListData = [];
            }
        },
        watch: {
            //显示状态
            state: function (newData) {
                if(newData)
                    this.initData();
            },
        }
    }
</script>

<style scoped>
    .form-box{

    }
    .body-box{
        padding-right: 10px;
    }
    .foot{
        display: flex;
        align-items: center;
        padding: 0px 20px 10px;
    }
    .foot>.attach-box{
        flex: 1;
        text-align: left;
    }
    .foot>.btn-box{
        flex: 1;
        text-align: right;
    }
    .split-icon{
        width: 2px;
        height: 15px;
        background-color: #cccccc;
        display: inline-block;
        margin: 0px 9px -2px;
    }
    .staff-box{
        clear: both;
        min-height: 20px;
        padding-left: 10px;
    }
</style>
